// extracted by mini-css-extract-plugin
export default {"wf-loading":"ZAYHHcbL0oHs7Xqhckfs"};